import { render } from "./DeleteCircleIcon.vue?vue&type=template&id=2a973734&ts=true"
import script from "./DeleteCircleIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteCircleIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DeleteCircleIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a973734"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a973734', __exports__)) {
    api.reload('2a973734', __exports__)
  }
  
  module.hot.accept("./DeleteCircleIcon.vue?vue&type=template&id=2a973734&ts=true", () => {
    api.rerender('2a973734', render)
  })

}


export default __exports__